module.exports = __webpack_public_path__ + "static/media/관음봉.d36daa9b.jpg";